import React from 'react';
import PropTypes from 'prop-types';

import { textToDateOrTime } from 'utils/common';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import classes from './ReleaseText.module.scss';

const ReleaseText = ({ textInfo }) => {
  const language = useUserState().user.language;

  return (
    <div className={classes.textBox}>
      <p className={classes.text}>{t('releaseText', 'RELEASE', language)}</p>
      <h2 className={classes.title}>{textInfo.title}</h2>
      <p className={classes.date}>{textToDateOrTime(textInfo.date, 'date')}</p>
      <div
        className={classes.textRelease}
        dangerouslySetInnerHTML={{ __html: textInfo.text }}
      />
    </div>
  );
};

ReleaseText.propTypes = {
  textInfo: PropTypes.object.isRequired
};

export default ReleaseText;
